import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Route, Switch, Redirect } from 'react-router-dom';
import { View } from '../../components/Common/react-native-components';
import { connect } from 'react-redux';

import get from 'lodash/get';
import getAssociatedHotels from '../../../../common/actions/getAssociatedHotels';
import signOut from '../../actions/signOut';

import EmptyScreen from '../../../../common/components/FetchHotelErrorHandler';
import NavigationBar from '../../components/NavigationBar';
import Footer from '../../components/Footer';
// import Page4 from './pages/Page4';
import Overview from '../Overview';
import NotFound from '../../components/NotFound';
import ProtectedRouteV2 from '../../AppRoutes/ProtectedRouteV2';
import FeedBackList from '../FeedBackList/containers';
import FeedBackDetails from '../FeedBackDetails/container';
import OnlineReview from '../OnlineReview';
import FilterBarContainer from '../Filters/container';
import Alerts from '../Alerts/container'
import ROUTES from '../../AppRoutes/RouteConstants';
import InsightsContainer from "../AiAnalytics/container"

const Dashboard = props => {

  useEffect(() => {
    fetchHotels();
  }, []);
  const {
    hasAppInitError,
    userDetails,
    language,
    getAssociatedHotels,
    history,
    computedMatch,
    allMessageFetched,
    activeHotelId
  } = props;

  const fetchHotels = onError => {
    const hotelId = computedMatch && computedMatch.params && computedMatch.params.hotel_id;
    const clear_cache = get(history, 'location.state.clear_cache', false);
    getAssociatedHotels({
      hotelId: hotelId === ':hotel_id' ? '' : hotelId,
      history,
      userDetails,
      language,
      clear_cache,
      onError,
      allMessageFetched
    });
  };
  if (hasAppInitError)
    return (
      <div>
        <EmptyScreen fetchHotels={fetchHotels} />
      </div>
    );

  return (
    <View style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <NavigationBar signOut={props.signOut} />

      {activeHotelId && (
        <View style={{ marginTop: '76px' }}>
          <FilterBarContainer />
          <Switch>
            <Route exact path={ROUTES.DASHBOARD} render={() => <Redirect to={ROUTES.OVERVIEW} />} />
            <ProtectedRouteV2
              path={ROUTES.OVERVIEW}
              component={props => (
                <>
                  <Overview {...props} />
                </>
              )}
            />
            <ProtectedRouteV2
              path={ROUTES.ONLINE_REVIEW}
              component={props => (
                <>
                  <OnlineReview {...props} />
                </>
              )}
            />
            <ProtectedRouteV2
              path={ROUTES.FEEDBACK}
              component={props => (
                <>
                  <FeedBackList {...props} />
                </>
              )}
            />

            <ProtectedRouteV2 path={'/dashboard/feedback_details/:feedback_id'} component={FeedBackDetails} />
            <ProtectedRouteV2
              path={ROUTES.ALERTS}
              component={props => (
                <>
                  <Alerts {...props} />
                </>
              )}
            />
            <ProtectedRouteV2
              path={ROUTES.AI_INSIGHTS}
              component={props => (
                <>
                  <InsightsContainer {...props} />
                </>
              )}
            />

            <ProtectedRouteV2 path={ROUTES.DEFAULT} component={NotFound} />
          </Switch>
        </View>
      )}
      <Footer />
    </View>
  );
};

const mapStateToProps = state => ({
  hasAppInitError: state.app.hasAppInitError,
  activeHotelId: state.app.active_hotel_id
});
const mapDispatchToProps = {
  signOut,
  getAssociatedHotels
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
